import { render } from "./ReAgreeTermsPopup.vue?vue&type=template&id=567bab39&scoped=true&ts=true"
import script from "./ReAgreeTermsPopup.vue?vue&type=script&lang=ts"
export * from "./ReAgreeTermsPopup.vue?vue&type=script&lang=ts"

import "./ReAgreeTermsPopup.vue?vue&type=style&index=0&id=567bab39&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_eu_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-567bab39"]])

export default __exports__